import React, { useState } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import SidebarMenu from '../SidebarMenu';
import { useTranslation } from 'react-i18next';
import { Images } from '../../assets/common';
import SubscriptionPopup from "../SubscriptionPopup"; // Import the popup component

export default function LeftBarMenuBox({ index, setIndex, toggleNav, isPremium }) {
  const { t } = useTranslation("common");
  const [showPremiumPopup, setShowPremiumPopup] = useState(false); // State to control the popup visibility

  // Function to handle opening the popup
  const handleUpgradeClick = (i) => {
    console.log("Upgrade button clicked"); // Debugging log to check if it's being triggered
    setIndex(i);
    setShowPremiumPopup(true); // Open the popup
    toggleNav(false); // Close the sidebar
  };

  // Function to close the popup
  const closePopup = () => {
    setShowPremiumPopup(false); // Close the popup
  };

  return (
    <Box id="sideBarMenuBox">
      <Stack spacing={1.5}>
        <Typography color="default" className="fs-11 ls2-2" sx={{ padding: "0 20px" }}></Typography>

        <SidebarMenu
          index={1}
          activeIndex={index}
          image={index === 1 ? Images.primium_enter : Images.premium_default}
          onClick={() => handleUpgradeClick(1)} // Open the popup on click
          toggleDrawer={() => toggleNav(false)}
          isSelected={index === 1 ? {} : { filter: 'grayscale(100%) brightness(0) sepia(1) hue-rotate(200deg) saturate(500%)', color: '#6A6A9F' }}
        />

        {/* Other Sidebar Menu Items */}
       {/* SidebarMenu Items */}
       <SidebarMenu
            index={0}
            activeIndex={index}
            path="/app/Home"
            image={index === 0 ? Images.home_enter : Images.home_default}
            onHover={() => handleHover(null)}
            onClick={(i) => setIndex(i)}
            toggleDrawer={() => toggleNav(false)}
            sx={index === 0 ? {} : { filter: 'grayscale(100%) brightness(0) sepia(1) hue-rotate(200deg) saturate(500%)', color: '#6A6A9F' }} // Apply the color when not selected
            />
        <SidebarMenu
          index={5}
          activeIndex={index}
          path={"/app/Nft/music"}
          image={index === 5 ? Images.nft_y : Images.nft_default}
          onClick={(i) => setIndex(i)}
          toggleDrawer={() => toggleNav(false)}
          isSelected={index === 5 ? {} : { filter: 'grayscale(100%) brightness(0) sepia(1) hue-rotate(200deg) saturate(500%)', color: '#6A6A9F' }}
        />
        <SidebarMenu
          index={6}
          activeIndex={index}
          path={"/app/Subscription"}
          image={index === 6 ? Images.subs_enter : Images.subs_default}
          onClick={(i) => setIndex(i)}
          toggleDrawer={() => toggleNav(false)}
          isSelected={index === 6 ? {} : { filter: 'grayscale(100%) brightness(0) sepia(1) hue-rotate(200deg) saturate(500%)', color: '#6A6A9F' }}
        />
      </Stack>

      {/* Show the subscription popup if the state is true */}
      {showPremiumPopup && (
        <SubscriptionPopup isOpen={showPremiumPopup} onClose={closePopup} />
      )}
    </Box>
  );
}
